import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { PublicCustomerContext } from "@/api_client";
import { customerContextUpdateContextMutation } from "@/api_client/@tanstack/react-query.gen";
import { customerContextQueryKey } from "@/hooks/api/customer_context/customerContextQueryKey";

export const useSetCustomerContext = () => {
  const queryClient = useQueryClient();
  return useMutation({
    ...customerContextUpdateContextMutation(),
    onMutate: async (customerContext) => {
      await queryClient.cancelQueries({
        queryKey: customerContextQueryKey,
      });

      const previousContext = queryClient.getQueryData(customerContextQueryKey);

      queryClient.setQueryData(
        customerContextQueryKey,
        (oldContext: PublicCustomerContext) => ({
          ...oldContext,
          ...customerContext.body,
        }),
      );

      return { previousContext };
    },
    onError: (_, __, context) => {
      queryClient.setQueryData(
        customerContextQueryKey,
        context?.previousContext,
      );
    },
    onSuccess: (data) => {
      queryClient.setQueryData(customerContextQueryKey, data);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: customerContextQueryKey,
      });
    },
  });
};
